import(/* webpackMode: "eager", webpackExports: ["DreamCampus"] */ "/vercel/path0/src/components/marketing/DreamCampus.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Hero"] */ "/vercel/path0/src/components/marketing/Hero.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HowItWorks"] */ "/vercel/path0/src/components/marketing/HowItWorks.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PopularExams"] */ "/vercel/path0/src/components/marketing/PopularExams.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PYQsSection"] */ "/vercel/path0/src/components/marketing/PYQsSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Testimonials"] */ "/vercel/path0/src/components/marketing/Testimonials.tsx");
